import type { BucketlistCategory, BucketlistTrendInterval } from "api/types/bucketlist.types";

/** 모델 CATEGORY_CHOICES 파생 순서 (백엔드 정렬 순서와 정합) */
export const BUCKETLIST_CATEGORY_ORDER: BucketlistCategory[] = ["activity", "health", "travel", "hobby", "learning", "etc"];

/** 카테고리 한글 라벨 (API label 부재 시 폴백) */
export const BUCKETLIST_CATEGORY_LABEL: Record<BucketlistCategory, string> = {
  activity: "액티비티",
  health: "건강",
  travel: "여행",
  hobby: "취미",
  learning: "성장",
  etc: "기타",
};

/** 카테고리별 차트 색상 */
export const BUCKETLIST_CATEGORY_COLOR: Record<BucketlistCategory, string> = {
  activity: "#6366f1",
  health: "#10b981",
  travel: "#3b82f6",
  hobby: "#f59e0b",
  learning: "#8b5cf6",
  etc: "#94a3b8",
};

const FALLBACK_COLOR = "#cbd5e1";

export const colorForCategory = (category: string): string => BUCKETLIST_CATEGORY_COLOR[category as BucketlistCategory] ?? FALLBACK_COLOR;

export const labelForCategory = (category: string): string => BUCKETLIST_CATEGORY_LABEL[category as BucketlistCategory] ?? category;

export const BUCKETLIST_INTERVAL_OPTIONS: { value: BucketlistTrendInterval; label: string }[] = [
  { value: "month", label: "월별" },
  { value: "week", label: "주별" },
  { value: "day", label: "일별" },
];

export const BUCKETLIST_ACHIEVED_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "달성 전체" },
  { value: "true", label: "달성" },
  { value: "false", label: "미달성" },
];
